// 仅管理配置分组、视口高度和点位检索；不参与地图草稿、计算规则或接口数据。
export default {
  data () {
    return {
      editorTab: 'basic', editorHeight: 600, pointEditorOpen: false,
      pointSearch: '', pointPage: 1, pointPageSize: 8,
      editorTabs: [
        { key: 'basic', name: '基本信息' }, { key: 'cells', name: '单元编辑' },
        { key: 'layers', name: '图层对象' }, { key: 'schemes', name: '参考网格' },
        { key: 'parts', name: '部件类型' }, { key: 'points', name: '部件点位' }, { key: 'city', name: '2.5D城市配置' }
      ]
    }
  },
  computed: {
    interactionTitle () {
      if (this.sceneDrawingActive) return this.sceneEdit.section === 'landmarks' ? '请点击地图放置地标' : '正在绘制' + this.sceneEdit.kindName + ' · 已选择 ' + this.sceneEdit.points.length + ' 个点'
      if (this.drawing) return '正在绘制单元 · 已采集 ' + this.drawPoints.length + ' 个点'
      if (this.pointPicking) return this.pointBatchMode ? '正在批量点选 · 已选 ' + this.pointBatchLocations.length + ' 个位置 · 点击已选标记可取消' : '请在左侧地图点击城市部件位置'
      if (this.schemeSelecting) return '参考网格多选中 · 已选择 ' + this.selectedCells.length + ' 个单元'
      return ''
    },
    filteredPoints () {
      const keyword = this.pointSearch.toLowerCase()
      return this.partPoints.filter(point => !keyword || [point.id, point.name, point.key,
        this.parts.find(part => part.key === point.key)?.name].join(' ').toLowerCase().includes(keyword))
    },
    pointPageCount () { return Math.max(1, Math.ceil(this.filteredPoints.length / this.pointPageSize)) },
    currentPointPage () { return Math.max(1, Math.min(this.pointPage, this.pointPageCount)) },
    pagedPoints () { const start = (this.currentPointPage - 1) * this.pointPageSize; return this.filteredPoints.slice(start, start + this.pointPageSize) }
  },
  watch: {
    message () { this.queueEditorMeasure() },
    importOpen () { this.queueEditorMeasure() },
    selected (next, previous) {
      if (previous?.id && previous.id !== next?.id) {
        this.editorTab = 'basic'; this.pointSearch = ''; this.pointPage = 1; this.pointEditorOpen = false
      }
      this.queueEditorMeasure()
    }
  },
  mounted () {
    this.editorResizeHandler = () => this.queueEditorMeasure()
    window.addEventListener('resize', this.editorResizeHandler)
    if (typeof ResizeObserver !== 'undefined') {
      this.editorObserver = new ResizeObserver(this.editorResizeHandler)
      for (const selector of ['.page-header', '.map-template-selector']) {
        const element = this.$el.querySelector(selector)
        if (element) this.editorObserver.observe(element)
      }
    }
    this.queueEditorMeasure()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.editorResizeHandler)
    this.editorObserver?.disconnect()
    if (this.editorMeasureFrame) window.cancelAnimationFrame(this.editorMeasureFrame)
  },
  methods: {
    stopMapInteraction () { this.stopSceneDrawing(); this.cancelDraw(); this.pointPicking = false; this.schemeSelecting = false },
    queueEditorMeasure () {
      this.$nextTick(() => {
        if (this._isDestroyed) return
        if (this.editorMeasureFrame) window.cancelAnimationFrame(this.editorMeasureFrame)
        this.editorMeasureFrame = window.requestAnimationFrame(() => {
          const layout = this.$refs.editorLayout
          if (!layout) return
          const top = Math.max(16, layout.getBoundingClientRect().top)
          const minimum = Math.max(420, Math.min(640, window.innerHeight * .65))
          this.editorHeight = Math.round(Math.max(minimum, Math.min(860, window.innerHeight - top - 22)))
        })
      })
    },
    openEditorTab (key) {
      if (key !== 'layers') this.stopSceneDrawing()
      if (key !== 'points') this.pointPicking = false
      if (key === 'city' && this.setEditorView) this.setEditorView('ISOMETRIC')
      this.editorTab = key
      this.$nextTick(() => { if (this.$refs.editorScroll) this.$refs.editorScroll.scrollTop = 0 })
    },
    editorTabKeydown (event, key) {
      const index = this.editorTabs.findIndex(tab => tab.key === key)
      let next
      if (['ArrowRight', 'ArrowDown'].includes(event.key)) next = (index + 1) % this.editorTabs.length
      else if (['ArrowLeft', 'ArrowUp'].includes(event.key)) next = (index + this.editorTabs.length - 1) % this.editorTabs.length
      else if (event.key === 'Home') next = 0
      else if (event.key === 'End') next = this.editorTabs.length - 1
      else return
      event.preventDefault()
      this.openEditorTab(this.editorTabs[next].key)
      this.$nextTick(() => this.$el.querySelector('[data-config-tab="' + this.editorTab + '"]')?.focus())
    },
    newPoint () {
      if (this.readOnly || this.saving) return
      this.resetPointEditor()
      this.pointEditorOpen = true; this.openEditorTab('points')
    }
  }
}
